import axios from "../../api/axios";

export const fetchAbsenceTypes = async (controller) => {
  return axios({ method: "get", url: "/absences/types/", params: controller })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
};

export async function createAbsenceType(payload, controller = {}) {
  return axios
    .post(`/absences/types`, { absence_type: payload, params: controller })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateAbsenceType(payload) {
  return axios
    .put(`/absences/types/${payload.id}`, {
      absence_type: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchAbsenceType(payload) {
  return axios
    .get(`/absences/types/${payload}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}
